<template>
  <ElTableColumn
    class="column-with-help"
    :render-header="renderHeader"
    v-bind="$attrs"
    :prop="prop"
    v-on="$listeners"
  >
    <template slot-scope="{ row }">
      <slot v-if="$scopedSlots.default" :row="row" />
      <span v-else>
        {{ row[prop] }}
      </span>
    </template>
  </ElTableColumn>
</template>

<script>
import lang from '@/mixins/lang';
import { ElPopover } from '@@/element-ui';
export default {
  name: 'ColumnWithHelp',
  mixins: [lang],
  inheritAttrs: false,
  props: {
    content: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    prop: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    enTranslation: {
      type: String,
      default: '',
    },
  },
  computed: {
    showTooltip() {
      return this.content || this.title;
    },
  },
  methods: {
    renderHeader(h) {
      return h(
        ElPopover,
        {
          props: {
            placement: 'top',
            title: this.title,
            trigger: 'hover',
            disabled: !this.showTooltip,
            closeDelay: 0,
            popperClass: 'column-with-help__popover',
          },
        },
        [
          h('span', {
            domProps: {
              innerHTML: this.content,
            },
          }),
          h(
            'span',
            {
              slot: 'reference',
            },
            [
              h('span', {}, [
                this.label,
                this.showTooltip &&
                  h('i', {
                    class: 'el-icon-question column-with-help__q-icon',
                  }),
              ]),
              this.lang !== 'en' &&
                h(
                  'span',
                  {
                    class: 'column-with-help__translation',
                  },
                  this.enTranslation,
                ),
            ],
          ),
        ],
      );
    },
  },
};
</script>

<style lang="scss">
.column-with-help {
  &__q-icon {
    margin-left: calc($global-margin / 3);

    @include rtl() {
      margin-left: 0;
      margin-right: calc($global-margin / 3);
    }
  }

  &__popover {
    background-color: #20222a;
    color: #fff;
    max-width: 400px;

    .popper__arrow::after {
      border-top-color: #20222a !important;
    }
  }

  &__translation {
    font-size: 85%;
    color: $lb-color-secondary;
    display: block;
  }
}
</style>
